(function () {
  var SELECTOR = '[data-hww-slideshow]';

  function init(container) {
    var slides = container.querySelectorAll('[data-hww-slide]');
    if (slides.length < 2) return;

    var autoplay = container.dataset.autoplay !== 'false';
    if (!autoplay) return;

    var interval = parseInt(container.dataset.interval, 10) || 5000;
    var current = 0;
    var timer = null;

    function next() {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }

    function start() {
      if (timer) return;
      timer = setInterval(next, interval);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        start();
      } else {
        stop();
      }
    }, { threshold: 0.15 });

    observer.observe(container);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      stop();
      return;
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
